import Dashboard from '../pages/dashboard/dashboard';
import BasicAutomation from '../pages/Automation/BasicAutomation';
import Subscribers from '../pages/Subscribers/subscribers';
import Topics from '../pages/Segmentation/Topics/Topics';
import Segments from '../pages/Segmentation/Segments/segments';
import CampaignReport from '../pages/Campaigns/CampaignsReport/campaignsReport';
import ScheduleCampaign from '../pages/Campaigns/ScheduleCampaigns/scheduleCampaigns';
import CreateCampaigns from '../pages/Campaigns/createCampaigns';
import Integration from '../pages/Websites/Integration';
import WebsitesAndSetup from '../pages/Websites/WebsitesAndSetups';
import AddWebsites from '../pages/Websites/WebsiteHelpers/AddWebsite';
import ChangeIcon from '../pages/Websites/WebsiteHelpers/ChangeIcon';
import PasswordChange from '../pages/Authorization/passwordChange';
import EditWebsite from '../pages/Websites/WebsiteHelpers/EditWebsite';
import CreateSegment from '../pages/Segmentation/Segments/createSegment';
import WelcomeNotification from '../pages/Automation/BasicAutomation/WelcomeNotification';
import DripNotification from '../pages/Automation/BasicAutomation/DripNotification';
import RssSetup from '../pages/Automation/BasicAutomation/Rss';
import ThemeSettings from '../pages/Segmentation/Topics/ThemeSettings';
import Profile from '../pages/Authorization/Profile';
import PermissionPrompt from '../pages/Websites/PermissionPrompt';
import DesktopPrompt from '../pages/Websites/permissionPrompts/Desktop';
import MobilePrompt from '../pages/Websites/permissionPrompts/Mobile';
import GDPRPrompt from '../pages/Websites/permissionPrompts/GDPR';
import BellPrompt from '../pages/Websites/permissionPrompts/Bell';
import UserManagement from '../pages/UserManagement/UserManagement';
import AddAgent from '../pages/UserManagement/AddAgent';
import BillingsAndPlanning from '../pages/Profile/Planning';
import ShopifyAutomation from '../pages/Automation/ShopifyAutomation';
import ShopifyAbandonedCart from '../pages/Automation/ShopifyAutomation/ShopifyAbandonedCart';
import ShopifyBackInStock from '../pages/Automation/ShopifyAutomation/ShopifyBackInStock';
import ShopifyPrizeDrop from '../pages/Automation/ShopifyAutomation/ShopifyPriceDrop';
import ShopifyShippingNotification from '../pages/Automation/ShopifyAutomation/ShopifyShippingNotification';
import WooShippingNotification from '../pages/Automation/WooCommerceAutomation/WooShippingNotification';
import WooPrizeDrop from '../pages/Automation/WooCommerceAutomation/WooPriceDrop';
import WooBackInStock from '../pages/Automation/WooCommerceAutomation/WooBackInStock';
import WooAbandonedCart from '../pages/Automation/WooCommerceAutomation/WooAbandonedCart';
import WooCommerceAutomation from '../pages/Automation/WooCommerceAutomation';

const RouteConstant = [
    {
        path: '/dashboard',
        component: Dashboard,
        role: ['send', 'view', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/websites-setup',
        component: WebsitesAndSetup,
        role: ['send', 'view', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/add-website',
        component: AddWebsites, 
        role: ['send', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/edit-website',
        component: EditWebsite,
        role: ['send', 'view', 'edit'],
        userType: ['owner']
    },
    {
        path: '/change-icon',
        component: ChangeIcon, 
        role: ['send', 'view', 'edit'],
        userType: ['owner']
    },
    {
        path: '/websites-integration',
        component: Integration,
        role: ['send', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/permission-prompt',
        component: PermissionPrompt,
        role: ['send', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/desktop-prompt',
        keyword: 'desktop-permission-prompt',
        title: 'Desktop Prompt',
        component: DesktopPrompt,
        role: ['send', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/mobile-prompt',
        component: MobilePrompt,
        title: 'Mobile Prompt',
        keyword: 'mobile-permission-prompt',
        role: ['send', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/gdpr-prompt',
        keyword: 'gdpr-permission-prompt',
        title: 'GDPR Prompt',
        component: GDPRPrompt,
        role: ['send', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/bell-prompt',
        keyword: 'bell-notification',
        title: 'Bell Prompt',
        component: BellPrompt,
        role: ['send', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/create-campaign',
        component: CreateCampaigns,
        role: ['send'],
        userType: ['owner', 'agent']
    },
    {
        path: '/schedule-campaign',
        component: ScheduleCampaign,
        role: ['send', 'view', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/campaign-report',
        component: CampaignReport,
        role: ['send', 'view', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/segments',
        keyword: 'segmentation',
        title: 'Segments',
        component: Segments,
        role: ['send', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/create-segment',
        keyword: 'segmentation',
        title: 'Segments',
        component: CreateSegment,
        role: ['send', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/topics',
        component: Topics,
        keyword: 'topic',
        title: 'Topics',
        role: ['send', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/theme-settings',
        keyword: 'topic',
        title: 'Topics',
        component: ThemeSettings,
        role: ['send', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/basic-automation',
        component: BasicAutomation,
        role: ['send'],
        userType: ['owner', 'agent']
    },
    {
        path: '/welcome-notification',
        keyword: 'welcome-notification',
        title: 'Welcome Notification',
        component: WelcomeNotification,
        role: ['send'],
        userType: ['owner', 'agent']
    },
    {
        path: '/drip-notification',
        keyword: 'drip-notification',
        title: 'Drip Notification',
        component: DripNotification,
        role: ['send'],
        userType: ['owner', 'agent']
    },
    {
        path: '/rss-setup',
        keyword: 'rss-feed',
        title: 'Rss Feed',
        component: RssSetup ,
        role: ['send'],
        userType: ['owner', 'agent']
    },
    {
        path: '/shopify-automation',
        title: 'Shopify Automation',
        component: ShopifyAutomation,
        role: ['send'],
        userType: ['owner', 'agent'],
        keyword: 'shopify'
    },
    {
        path: '/shopify-abandoned-cart',
        title: 'Abandoned Cart Recovery',
        component: ShopifyAbandonedCart,
        role: ['send'],
        userType: ['owner', 'agent'],
        keyword: 'shopify'
    },
    {
        path: '/shopify-back-in-stock',
        title: 'Back In Stock',
        component: ShopifyBackInStock,
        role: ['send'],
        userType: ['owner', 'agent'],
        keyword: 'shopify'
    },
    {
        path: '/shopify-price-drop',
        title: 'Price Drop',
        component: ShopifyPrizeDrop,
        role: ['send'],
        userType: ['owner', 'agent'],
        keyword: 'shopify'
    },
    {
        path: '/shopify-shipping-notification',
        title: 'Shipping Notification',
        component: ShopifyShippingNotification,
        role: ['send'],
        userType: ['owner', 'agent'],
        keyword: 'shopify'
    },
    {
        path: '/woocommerce-automation',
        title: 'WooCommerce Automation',
        component: WooCommerceAutomation,
        role: ['send'],
        userType: ['owner', 'agent'],
        keyword: 'woocommerce',
    },
    {
        path: '/woocommerce-abandoned-cart',
        // keyword: 'abandoned-cart',
        title: 'Abandoned Cart Recovery',
        component: WooAbandonedCart,
        role: ['send'],
        userType: ['owner', 'agent'],
        keyword: 'woocommerce',
    },
    {
        path: '/woocommerce-back-in-stock',
        // keyword: 'abandoned-cart',
        title: 'Back In Stock',
        component: WooBackInStock,
        role: ['send'],
        userType: ['owner', 'agent'],
        keyword: 'woocommerce',
    },
    {
        path: '/woocommerce-price-drop',
        // keyword: 'abandoned-cart',
        title: 'Price Drop',
        component: WooPrizeDrop,
        role: ['send'],
        userType: ['owner', 'agent'],
        keyword: 'woocommerce'
    },
    {
        path: '/woocommerce-shipping-notification',
        // keyword: 'abandoned-cart',
        title: 'Shipping Notification',
        component: WooShippingNotification,
        role: ['send'],
        userType: ['owner', 'agent'],
        keyword: 'woocommerce'
    },
    {
        path: '/subscribers',
        component: Subscribers,
        role: ['send', 'view', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/profile',
        component: Profile, 
        role: ['send', 'view', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/reset-password',
        component: PasswordChange,
        role: ['send', 'view', 'edit'],
        userType: ['owner', 'agent']
    },
    {
        path: '/user-management',
        component: UserManagement,
        keyword: 'user-management',
        title: 'User Management',
        role: ['send', 'view', 'edit'],
        userType: ['owner']
    },
    {
        path: '/add-agent',
        component: AddAgent,
        keyword: 'user-management',
        title: 'User Management',
        role: ['send', 'view', 'edit'],
        userType: ['owner'],
    },
    {
        path: '/billing',
        component: BillingsAndPlanning,
        role: ['send', 'view', 'edit'],
        userType: ['owner', 'agent']
    },

];

export default RouteConstant;